// counter.actions.ts
import { Action } from '@ngrx/store';
import { Company } from '../models/company'

export const FETCH_REGIONS = '[Regions] FETCH_REGIONS';
export const FETCH_REGIONS_SUCCESS = '[Regions] FETCH_REGIONS_SUCCESS';
export const FETCH_REGIONS_FAILURE = '[Regions] FETCH_REGIONS_FAILURE';
export const CLEAR_REGIONS = '[Regions] CLEAR_REGIONS';

export class ClearRegions implements Action {
  readonly type = CLEAR_REGIONS;
  constructor() { }
}

export class FetchRegions implements Action {
  readonly type = FETCH_REGIONS;
  constructor() { }
}

export class FetchRegionsSuccess implements Action {
  readonly type = FETCH_REGIONS_SUCCESS;
  constructor(public payload: Company) {
  }
}

export class FetchRegionsFailure implements Action {
  readonly type = FETCH_REGIONS_FAILURE;
  constructor(public payload: any) {
  }
}

export type Actions = ClearRegions | FetchRegions | FetchRegionsSuccess | FetchRegionsFailure;



// WEBPACK FOOTER //
// ./src/actions/regions.actions.ts